import React, { useEffect, useMemo, useState } from 'react';
import Page from '../../../page';
import SolutionInfoCard from '../../../solutionInfo/SolutionInfoCard';
import SelectLocations from '../../../stepper/stepperBody/stepperBodyComponents/SelectLocations';
import StepperFooter from '../../../stepper/stepperFooter/StepperFooter'
import Overlay from '../../../Overlay/Overlay';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { setScreen } from '../../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { unsubscribeLocations, fetchSolutionConnections, disableConnection } from '../../../../redux/connectedComponent/removeLocations/removeLocations.slice';
import { screens } from '../../../config/uiFactory.config';
import { Loader } from 'cdk-radial';
import { Constants } from '../../../../constants/constants';
import './removeLocations.scss';
import { sendAmplitudeData } from  '../../../../utils/amplitude';
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from '../../../../constants/amplitudeConstants';
import { trackPageView, PAGE_SECTIONS, PAGE_SUBSECTIONS } from '../../../../utils/gtm';

const ADDITION = 'addition';
const DIALOG_STYLE = {width:'550px'};
const COLOR_STROKE = 'rgba(21,27,37,0.4)';
const REMOVING = 'Removing...';
const REMOVE = 'Remove';
const CANCEL = 'Cancel';
const POSITIVE = 'positive';
const NEGATIVE = 'negative';
const REMOVE_LOCATIONS_FAILURE = 'Unable to remove locations. Please try again';

const RemoveLocations = ({solutionData = {overview: {}}, subscriptionData ={}, isBulkSubscribed}) => {

    const id = solutionData.id;
    let name, publisherName, solutionLogo;

    if (solutionData.isAppNotListed) {
      name = solutionData.displayName;
      publisherName = solutionData.orgName;
    } else {
      const { overview } = solutionData;
      name = overview.name;
      publisherName = overview.publisherName;
      solutionLogo = overview.solutionLogo
    }

    const dispatch = useDispatch();
    const [locationsToBeRemoved, setLocationsToBeRemoved] = useState([]);
    const [disableNextButton, setDisableNextButton] = useState(true);
    const [openRemoveLocationsConfirmation, setOpenRemoveLocationsConfirmation] = useState(false);
    const [showDialogSpinner, setShowDialogSpinner] = useState(false);

    const state = useSelector(state => state);
    const allLocations = state.loginDetailsSlice.allLocations;
    const token = state.loginDetailsSlice.authenticationToken;
    const userEmail = state.loginDetailsSlice.userEmail;
    const connectionIdsToBeDisabled = state.removeLocationsSlice.connectionIdsToBeDisabled;
    const fetchSolutionConnectionsPending = state.removeLocationsSlice.fetchSolutionConnectionsPending;
    const isDisableSolutionConnectionPending = state.removeLocationsSlice.isDisableSolutionConnectionPending;
    const isUnsubscribeLocationsPending = state.removeLocationsSlice.isUnsubscribeLocationsPending;
    const fetchSolutionConnectionsFulfilled = state.removeLocationsSlice.fetchSolutionConnectionsFulfilled;
    const isDisableSolutionConnectionFulfilled = state.removeLocationsSlice.isDisableSolutionConnectionFulfilled;
    const isUnsubscribeLocationsFulfilled = state.removeLocationsSlice.isUnsubscribeLocationsFulfilled;
    const { isSolutionInfoSuccess,constants,solutionInfo } = useSelector(state => state.solutionInfoSlice);
    const firstName = state?.loginDetailsSlice?.decodedToken?.firstName;
    const lastName = state?.loginDetailsSlice?.decodedToken?.lastName;
    const isAppNotListed = solutionData?.isAppNotListed;

    const namesToBeRemoved = useMemo(() => locationsToBeRemoved.map(orgId => {
      return allLocations?.find(location => location.entityId === orgId)?.partyName;
    }), [allLocations, locationsToBeRemoved]);

    useEffect(() => {
      trackPageView({
        page_section: PAGE_SECTIONS.APP_MANAGEMENT,
        page_subsection: PAGE_SUBSECTIONS.REMOVE_LOCATIONS,
      });
    }, []);

    useEffect(() => {
      if (connectionIdsToBeDisabled && connectionIdsToBeDisabled.length) {
        dispatch(disableConnection({ connectionIds: connectionIdsToBeDisabled, token }))
      }
    }, [connectionIdsToBeDisabled]);

    useEffect(()=>{
      if (!isUnsubscribeLocationsPending && !fetchSolutionConnectionsPending && connectionIdsToBeDisabled && connectionIdsToBeDisabled.length === 0) {
        if (isUnsubscribeLocationsFulfilled && fetchSolutionConnectionsFulfilled) {
          const REMOVE_LOCATIONS_SUCCESS = `You removed ${locationsToBeRemoved.length} ${locationsToBeRemoved.length === 1 ? `location` : `locations`} from your ${name} ${solutionInfo.activateOnly!==false ? `activation` : `subscription`}.`;
          dispatch(
            setScreen({
              screen: screens.SUBSCRIPTION_MANAGEMENT,
              additionalData: {
                notificationContent: REMOVE_LOCATIONS_SUCCESS,
                notificationType: POSITIVE,
                showNotification: true
              }
            }));
        }
        else {
          dispatch(
            setScreen({
              screen: screens.SUBSCRIPTION_MANAGEMENT,
              additionalData: {
                notificationContent: REMOVE_LOCATIONS_FAILURE,
                notificationType: NEGATIVE,
                showNotification: true
              }
            }));
        }
      } else if (!isUnsubscribeLocationsPending && !fetchSolutionConnectionsPending && !isDisableSolutionConnectionPending && connectionIdsToBeDisabled && connectionIdsToBeDisabled.length !== 0) {
          if (isUnsubscribeLocationsFulfilled && fetchSolutionConnectionsFulfilled && isDisableSolutionConnectionFulfilled) {
            const REMOVE_LOCATIONS_SUCCESS = `You removed ${locationsToBeRemoved.length} ${locationsToBeRemoved.length === 1 ? 'location' : 'locations'} from your ${name} ${solutionInfo.activateOnly !== false ? 'activation' : 'subscription'}.`;
            dispatch(
              setScreen({
                screen: screens.SUBSCRIPTION_MANAGEMENT,
                additionalData: {
                  notificationContent: REMOVE_LOCATIONS_SUCCESS,
                  notificationType: POSITIVE,
                  showNotification: true
                }
              }));
          }
          else {
            dispatch(
              setScreen({
                screen: screens.SUBSCRIPTION_MANAGEMENT,
                additionalData: {
                  notificationContent: REMOVE_LOCATIONS_FAILURE,
                  notificationType: NEGATIVE,
                  showNotification: true
                }
              }));
          }
      }
      else if( (isBulkSubscribed || isAppNotListed) && isUnsubscribeLocationsFulfilled ){
        const REMOVE_LOCATIONS_SUCCESS = `You removed ${locationsToBeRemoved.length} ${locationsToBeRemoved.length === 1 ? 'location' : 'locations'} from your ${name} ${solutionInfo.activateOnly!==false ? 'activation' : 'subscription'}.`;
        dispatch(
          setScreen({
            screen: screens.SUBSCRIPTION_MANAGEMENT,
            additionalData: {
              notificationContent: REMOVE_LOCATIONS_SUCCESS,
              notificationType: POSITIVE,
              showNotification: true
            }
          }));
      }
    }, [fetchSolutionConnectionsPending, isDisableSolutionConnectionPending, isUnsubscribeLocationsPending]);

    function onNext() {
        setOpenRemoveLocationsConfirmation(true);
    }

    function onPrevious() {
      dispatch(setScreen({screen: screens.SUBSCRIPTION_MANAGEMENT}));
    }

      function handleCancel() {
        sendAmplitudeData(AMPLITUDE_EVENTS.REMOVE_LOCATIONS_CANCEL, {
          [AMPLITUDE_PROPERTIES.APP_NAME]: solutionData?.overview?.name,
          [AMPLITUDE_PROPERTIES.APP_ID]: solutionData?.id
        });
        setOpenRemoveLocationsConfirmation(false);
      }

      function handleRemove() {
        setShowDialogSpinner(true);
        let locationsToBeRemovedObj = allLocations && allLocations.filter(loc => locationsToBeRemoved.includes(loc.entityId));
        sendAmplitudeData(AMPLITUDE_EVENTS.REMOVE_LOCATIONS_CONFIRM, {
          [AMPLITUDE_PROPERTIES.APP_NAME]: solutionData?.overview?.name,
          [AMPLITUDE_PROPERTIES.APP_ID]: solutionData?.id,
          [AMPLITUDE_PROPERTIES.LOCATIONS]: locationsToBeRemovedObj.map(
            (loc) => ({
              [AMPLITUDE_PROPERTIES.ORG_ID]: loc?.entityId,
              [AMPLITUDE_PROPERTIES.ORG_NAME]: loc?.location,
              [AMPLITUDE_PROPERTIES.ORG_CMF]: loc?.cmfNumber,
            })
          ),
        });

        let subscriptions = [];
        locationsToBeRemovedObj.forEach(loc => {
          let subscription = subscriptionData.filter(sub => sub.entityId === loc.entityId);
          if (subscription) {
            subscriptions.push({
              subscriptionId: subscription[0].subscriptionId,
              orgName: loc.orgName,
              entitycmfNumber: subscription[0].entitycmfNumber,
              entityId: subscription[0].entityId,
            });
          }
        });
        dispatch(
          unsubscribeLocations({
            solutionId: id,
            entityIdList: locationsToBeRemoved,
            token,
            isBulkSubscribed: isBulkSubscribed || isAppNotListed,
            buyerName: `${firstName} ${lastName}`,
            buyerEmail: userEmail,
            subscriptions,
            solutionData
          })
        );
        if (!isBulkSubscribed && !isAppNotListed) {
          dispatch(
            fetchSolutionConnections({
              solutionId: id,
              entities: locationsToBeRemoved,
              token
            })
          );
        }
      }

      function handleLocationSelection(entityId, type) {
        if (type === ADDITION) {
            setLocationsToBeRemoved([...locationsToBeRemoved, entityId]);
            setDisableNextButton(false);
        } else {
            let filteredLocations = locationsToBeRemoved.filter(loc => loc !== entityId);
            if (!filteredLocations.length) {
              setDisableNextButton(true);
            }
            setLocationsToBeRemoved([...filteredLocations]);
        }
      }
    return (
    <Page>
      <SolutionInfoCard solutionId={id} appName={name} publisherName={publisherName} solutionLogo={solutionLogo} isAppNotListed={solutionData?.isAppNotListed} orgName={solutionData?.orgName} />
      <>
      <div className="remove-locations-container">
                 {/* re-use existing component  */}
                { isSolutionInfoSuccess || isBulkSubscribed || isAppNotListed ? <SelectLocations
                    title = {constants.REMOVE_LOCATIONS_TITLE}
                    description = {constants.REMOVE_LOCATIONS_DESCRIPTION}
                    allLocations = {allLocations && allLocations.length && allLocations.map(location => location.partyName)}
                    allLocationsCMFandEntityId = {allLocations}
                    disableNextButton = {() => {}}
                    showBadge = {false}
                    customHandlerForLocationSelection = {handleLocationSelection}
                    customLocations={locationsToBeRemoved}
                    solutionId={id}
                    isRemoveLocations={true}
                    isBulkSubscribed={isBulkSubscribed}
                    isAppNotListed={isAppNotListed}
                    subscriptionData={subscriptionData}
                    allLocationsWithDetails={allLocations}
                    key="1"
                  /> :
                  <SelectLocations
                    title = {constants.REMOVE_LOCATIONS_TITLE}
                    description = {constants.REMOVE_LOCATIONS_DESCRIPTION}
                    allLocations = {[]}
                    allLocationsCMFandEntityId = {[]}
                    disableNextButton = {() => {}}
                    showBadge = {false}
                    customHandlerForLocationSelection = {() => {}}
                    customLocations={[]}
                    solutionId={id}
                    isRemoveLocations={true}
                    allLocationsWithDetails={[]}
                    key="2"
                    hideLocations={true}
                  />
                }
            </div>
            <div className="remove-locations-footer">
                <StepperFooter
                    isLastStep={false}
                    onNext={onNext}
                    onPrevious={onPrevious}
                    disableNextButton={disableNextButton}
                    disablePreviousButton={false}
                />
            </div>
                <Overlay
                active={openRemoveLocationsConfirmation}
                title={`Removing ${locationsToBeRemoved.length} ${locationsToBeRemoved.length===1 ? `Location` : Constants.LOCATIONS}`}
                onOverlayClose={handleCancel}
                onOverlayAccept={handleRemove}
                firstButtonText={CANCEL}
                hideFirstButton={showDialogSpinner}
                disableFirstButton={showDialogSpinner}
                disableSecondButton={showDialogSpinner}
                secondButtonText={showDialogSpinner ? <Loader label={REMOVING} style={{stroke: COLOR_STROKE}}/> : REMOVE}
                hideCloseButton={false}
                hideHeader={false}
                customeStyle={DIALOG_STYLE}>
                    <div className="remove-locations-overlay-body">
                        <p>The following {locationsToBeRemoved.length} {locationsToBeRemoved.length===1 ? `location` : `location(s)`} will be removed from your app {solutionInfo.activateOnly!==false ? `activation` : `subscription`}: </p>
                        <ul>
                          {namesToBeRemoved.map((location, index) => {
                              return <li key={index}>{location}</li>
                          })}
                        </ul>
                        <p><strong>Warning:</strong> This will cancel integrations from these {locationsToBeRemoved.length===1 ? `location` : `location(s)`}, which may cause breaking changes.</p>
                    </div>
                </Overlay>
          </>
    </Page>
    );

}

export default withRouter(RemoveLocations);
